/* CONTRABAND experience layer: case-file entry gate.
   Music removed 2026-08-01 — gate shows once per browser session, no audio. */
(function(){
  'use strict';
  var loader = document.getElementById('cbxLoader');
  if (!loader) return;
  var entered = false;
  try { entered = sessionStorage.getItem('cbxEntered') === '1'; } catch(_){}
  if (entered) return;
  var gateDone = false;
  function enterSite(){
    if (gateDone) return;
    gateDone = true;
    try { sessionStorage.setItem('cbxEntered', '1'); } catch(_){}
    loader.classList.add('done');
  }
  loader.classList.add('show');
  setTimeout(function(){ loader.classList.add('ready'); }, 1200);
  setTimeout(enterSite, 14000);
  var btn = document.getElementById('cbxEnter');
  if (btn) btn.addEventListener('click', enterSite);
})();
